import { useEffect, useState } from 'react'
import { isEmpty, isNil, isObject } from 'lodash'

import { LIMIT_SIZE_IMAGE } from '../../utils/constants'
import { MESSAGES } from '../../utils/recipeLimits'

import './CustomInputFile.css'

// Phones and tablets have no mouse, so nothing ever "leaves" the photo to reveal it
const canHover = () => !!window.matchMedia && window.matchMedia('(hover: hover)').matches

const CustomInputFile = ({
  value,
  error,
  onChange = () => {},
  idName = 'file',
  classInner = '',
  buttonClass = '',
  setExternal = () => {},
  isAlwaysShow = false,
  globalInnerClassName = '',
  textButton = 'Upload a Recipe Photo',
  emptyContent = null,
}) => {
  const [image, setImage] = useState('')
  const [bigSize, setBigSize] = useState('')
  const [defaultShowUploadButton, setDefaultShowUploadButton] = useState(canHover)

  const classNameDefaultShowUploadButton = defaultShowUploadButton ? 'showDefaultUploadButton' : ''
  const classNameHideBtnUpload = !isEmpty(image) ? 'hideBtnUpload' : ''

  useEffect(() => {
    if (!isObject(value)) {
      setImage(value)
      setExternal(value)
    }
  }, [value])

  const removeImage = () => {
    setExternal('')
    onChange('')
    setImage('')
  }

  return (
    <div className={`innerUploadedFile ${globalInnerClassName}`}>
      <div
        onMouseLeave={() => setDefaultShowUploadButton(isAlwaysShow)}
        className={`recipeUploadWrap ${classInner} ${
          error ? 'borderError' : ''
        } ${classNameHideBtnUpload} ${classNameDefaultShowUploadButton}`}
      >
        {/* No <img> without a picture, or browsers draw a broken-image icon */}
        {image ? <img className="formPhotoRecipe" src={image} alt="" /> : emptyContent}
        <input
          onChange={(e) => {
            const file = e.target?.files?.[0]
            if (file?.size > LIMIT_SIZE_IMAGE) {
              return setBigSize(MESSAGES.photoTooBig(file.size))
            }
            if (file?.type && !/^image\/(jpe?g|png)$/i.test(file.type)) {
              return setBigSize(MESSAGES.photoWrongType)
            }
            if (!isNil(file)) {
              const image = URL.createObjectURL(file)
              setBigSize('')
              onChange(file)
              setImage(image)
              setExternal(image)
              // Show the chosen photo right away, not faded behind the upload button
              setDefaultShowUploadButton(false)
            }
          }}
          id={idName}
          className="inputFilePhoto"
          type="file"
          accept=".png, .jpg, .jpeg"
        />
        <label className={`recipeButtonUpload buttonWrapper ${buttonClass}`} htmlFor={idName}>
          {textButton}
        </label>
      </div>
      <div className="innerImageSettings">
        {bigSize || error?.message ? (
          <p className="errorBigImage formFieldError" role="alert">
            {bigSize || error?.message}
          </p>
        ) : null}
        {!buttonClass && !isEmpty(image) ? (
          <button
            type="button"
            onClick={removeImage}
            className="removeImageBtn btn btn-outline-danger mr-1"
          >
            Remove image
          </button>
        ) : null}
      </div>
    </div>
  )
}

export default CustomInputFile
